<template>
  <q-table
    ref="compare-table"
    id="compare-table"
    :title="title"
    :data="dataFixed"
    :columns="columns"
    row-key="name"
    fit
    :pagination="{
      page: 1,
      rowsPerPage: rowsPerPage,
      rowsNumber: dataFixed.length
    }"
  >
    <template v-slot:header-cell="props">
      <q-th
        :props="props"
        :class="`bg-grey-1 ${props.col.class ? props.col.class : ''}`"
      >
        {{ props.col.label }}
      </q-th>
    </template>

    <template v-slot:body-cell="props">
      <q-td
        :props="props"
        :class="`${props.pageIndex % 2 !== 0 ? 'bg-grey-1' : ''} `"
        v-if="!props.value"
        >-
      </q-td>
      <q-td
        :props="props"
        :class="`${props.pageIndex % 2 !== 0 ? 'bg-grey-1' : ''} ${
          props.value.class ? props.value.class : ''
        }`"
        v-else
      >
        {{ props.value.value ? props.value.value : props.value }}
      </q-td>
    </template>
  </q-table>
</template>
<script>
export default {
  name: 'DCompareTable',
  props: {
    card: {
      required: true,
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      content: null,
      dataFixed: [],
      columns: [],
      parentMetas: null,
      title: null,
      rowsPerPage: 10
    }
  },
  created() {
    this.content = this.card.compare
    this.columns = this.content.columns
    this.parentMetas = this.card.parentMetas
    this.title = this.content.title
    this.rowsPerPage = this.content.rowsPerPage ?? 10

    if (!this.content.data[0].dynamic) {
      this.dataFixed = this.content.data ?? []
      return
    }

    this.dataFixed = this.content.data.map((d) => {
      const { dynamic, ...rest } = d
      return {
        ...rest,
        ...this.filterValuesByMetas(dynamic)
      }
    })
  },
  mounted() {
    this.$refs['compare-table'].$el.querySelector(
      '#compare-table .q-table__bottom'
    ).style.display = 'none'
  },
  methods: {
    filterValuesByMetas(dynamic) {
      if (!this.parentMetas) {
        return {}
      }
      const metaName = dynamic.validation.metas.meta ?? 'parentId'
      if (!this.parentMetas[metaName]) {
        return {};
      }
      const match = dynamic.items.find((i) => {
        switch (dynamic.validation.metas.logic) {
          case '!=':
            return (
              i.ref.toLowerCase() !== this.parentMetas[metaName].toLowerCase()
            )
          case '>':
            return (
              i.ref.toLowerCase() > this.parentMetas[metaName].toLowerCase()
            )
          case '>=':
            return (
              i.ref.toLowerCase() >= this.parentMetas[metaName].toLowerCase()
            )
          case '<':
            return (
              i.ref.toLowerCase() < this.parentMetas[metaName].toLowerCase()
            )
          case '<=':
            return (
              i.ref.toLowerCase() <= this.parentMetas[metaName].toLowerCase()
            )
          case 'includes':
            if (this.parentMetas[metaName] instanceof Array) {
              return this.parentMetas[metaName]
                .map((t) => t.toLowerCase())
                .includes(i.ref.toLowerCase())
            }
            return this.parentMetas[metaName]
              .toLowerCase()
              .includes(i.ref.toLowerCase())
          default:
            return (
              i.ref.toLowerCase() === this.parentMetas[metaName].toLowerCase()
            )
        }
      })
      return match?.values ?? {}
    }
  }
}
</script>
